import AddressTypes from 'common/Forms/AddressTypes';
import { GetCommonWFormWellFormedAddress, GetCommonWFormFieldPathValueMap } from 'common/Addresses/AddressFormatters/Shared/AddressFormatHelper';

export function GetFieldPathValueMap(addressProps, wellFormedAddress) {
  switch (addressProps?.addressType) {
    case AddressTypes.Permanent:
      return GetCommonWFormFieldPathValueMap('part1.permanentAddress', wellFormedAddress);
    case AddressTypes.Mailing:
      return GetCommonWFormFieldPathValueMap('part1.mailingAddress', wellFormedAddress);
    default:
      break;
  }
}

export function GetWellFormedAddress(addressProps, addressValues) {
  switch (addressProps?.addressType) {
    case AddressTypes.Permanent:
      return GetCommonWFormWellFormedAddress(addressValues?.part1?.permanentAddress);
    case AddressTypes.Mailing:
      return GetCommonWFormWellFormedAddress(addressValues?.part1?.mailingAddress);
    default:
      break;
  }
}
